
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.411 8.029L15.85 6.59a.5.5 0 000-.707l-.707-.707a.5.5 0 00-.707 0l-1.439 1.439-1.434-1.434a.5.5 0 00-.707 0l-.707.707a.5.5 0 000 .707l1.434 1.434-1.434 1.434a.5.5 0 000 .707l.707.707a.5.5 0 00.707 0l1.434-1.434 1.439 1.439a.5.5 0 00.707 0l.707-.707a.5.5 0 000-.707l-1.439-1.439zM8.041.136L4 4.007H1c-.553 0-1 .484-1 1.026v5.952c0 .542.447 1.021 1 1.021h3l4.062 3.904S9 16.472 9 14.845V1.108C9-.536 8.041.136 8.041.136z"}})])
          )
        }
      }
    